import useScrollReset from 'src/shared/hooks/useScrollReset';
// ! WE CAN USE THIS DIRECTLY WITH THE HOOK
const ScrollReset = (): null => {
  useScrollReset();

  return null;
};

export default ScrollReset;
